//import logo from './logo.svg';
import './App.css';
import React from 'react';
import Header from './components/Header';
import Main from './components/Main/Main';
import {Menu} from './components/Menu/Menu';
import { Baniere } from './components/Baniere/Baniere';
import { Apropos } from './components/Apropos/Apropos';
import { Partenaires } from './components/Partenaire/Partenaires';
import { Services } from './components/Services/Services';
import { Operations } from './components/Operations/Operations';
import { Gallery } from './components/Gallery/Gallery';
import { Contact } from './components/Contact/Contact';
import { Footer } from './components/Footer/Footer';

function App() {
  return (
    <div className="container">
       <nav><Header/></nav>
       <main><Main /></main>
       <div id="menu"><Menu /></div>
       <div id="baniere"><Baniere /></div>
       <div id="apropos"><Apropos /></div>
       <div id="confiance"><Partenaires /></div>
       <div id="services"><Services /></div>
       <div id="operations"><Operations /></div>
       <div id="gallery"><Gallery /></div>
       <div id="contact"><Contact /></div>
       <footer><Footer /></footer>
    </div>
  );
}

export default App;
